
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceindhule() {



const cardData = {
  keyword: 'Cab Service in Dhule MIDC',
  heading: 'eTravo: Cab Service in Dhule MIDC',
  headingDescription: `eTravo offers trusted and efficient cab services in Dhule MIDC, crafted to support the transportation needs of businesses, employees, and corporate executives in this rapidly growing industrial area. From streamlined staff commute solutions to premium executive and client travel, our services are built on punctuality, professionalism, and comfort. Our fleet features GPS-equipped, air-conditioned vehicles operated by skilled drivers trained in corporate protocol. With flexible rental plans, efficient route management, and dedicated customer support, eTravo ensures a smooth, hassle-free travel experience across Dhule MIDC. Partner with eTravo for dependable daily transport and elevate your corporate mobility standards in the Dhule industrial zone.`,

  top: 'Top Places to visit in Dhule with eTravo',
    "topPlaces": [
    {
      "title": "Dhule MIDC Industrial Area",
      "description": "Dhule's MIDC Industrial Area is a prominent hub hosting a diverse range of industries, including agro-processing units, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Nardana Industrial Estate",
      "description": "Located near Dhule, the Nardana Industrial Estate is an emerging industrial zone with a focus on agro-based industries and manufacturing units. eTravo provides reliable cab services for employees and executives, facilitating smooth transportation to and from the estate."
    },
    {
      "title": "Dhule City Center",
      "description": "The commercial and administrative heart of Dhule, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Dhule Railway Station",
      "description": "A crucial railway hub connecting Dhule with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Safexpress Logistics Park",
      "description": "Safexpress has established a state-of-the-art logistics park in Dhule, enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Shirpur Industrial Area",
      "description": "An industrial zone near Dhule, Shirpur is home to various manufacturing units and processing plants. eTravo provides dependable cab services for employees and executives, ensuring efficient transportation to and from the area."
    },
    {
      "title": "North Maharashtra University",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Dhule",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Dhule Retail and Shopping Centers",
      "description": "Facilitating transportation for employees and customers to and from major retail outlets and shopping centers in Dhule. eTravo's services enhance the shopping experience by providing convenient and safe travel options."
    },
    {
      "title": "Dhule Hospitality Sector",
      "description": "Providing transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry. eTravo's services contribute to guest satisfaction and operational efficiency."
    }
  ],

services: [
  {
    name: 'Dhule MIDC Corporate Cab Rentals',
    description: `Custom corporate cab rental packages designed for businesses in Dhule MIDC, offering both short-term and long-term rental options. Our services support smooth business operations with a well-maintained fleet, flexible booking, and dedicated customer service, ensuring your corporate travel needs are met reliably and efficiently.`
  },
  {
    name: 'Employee Transport Cab Dhule MIDC',
    description: `Dependable employee transport services aligned with factory and office shift timings in Dhule MIDC. Equipped with GPS tracking and real-time monitoring, our cabs ensure safe, punctual, and comfortable commutes, enhancing workforce productivity and satisfaction.`
  },
  {
    name: 'Business Cab Services Dhule MIDC',
    description: `Efficient cab services tailored for business professionals traveling for meetings, client visits, and site inspections. Our drivers are experienced and knowledgeable about local routes, providing timely and hassle-free travel within Dhule and surrounding areas.`
  },
  {
    name: 'Corporate Staff Cabs Dhule MIDC',
    description: `Group transport solutions featuring multi-route planning and GPS tracking, ideal for corporate teams commuting together. This service helps companies reduce costs, manage traffic congestion, and ensure employee safety through coordinated pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Dhule MIDC',
    description: `Our commitment to quality includes clean, well-maintained vehicles and courteous, professional drivers. We focus on punctuality, transparent communication, and personalized services tailored to the specific needs of corporate clients in Dhule MIDC.`
  },
  {
    name: 'AC Corporate Cabs Dhule MIDC',
    description: `Comfortable air-conditioned cabs designed to provide a pleasant travel experience regardless of Dhule’s climate. Ideal for daily commutes and executive travel, our AC fleet ensures a cool and relaxing journey during all seasons.`
  },
  {
    name: 'Staff Pickup and Drop Cab Dhule MIDC',
    description: `Comprehensive staff transport services supporting multiple shifts, including night duties, with flexible scheduling and timely pickups. Our 24/7 availability and experienced drivers ensure workforce safety and punctuality throughout the day and night.`
  },
  {
    name: 'Affordable Business Cab Rentals Dhule MIDC',
    description: `Budget-friendly cab rental options for businesses of all sizes, featuring transparent pricing and adaptable plans. Our scalable services enable companies to optimize transportation costs without compromising on service quality or reliability.`
  },
  {
    name: 'Executive Cab Services Dhule MIDC',
    description: `Premium executive transportation with luxury vehicles and professionally trained chauffeurs. Perfect for airport transfers, VIP meetings, and client hospitality, ensuring a refined and comfortable travel experience for senior management and guests.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Dhule MIDC',
    description: `Fixed-route monthly rental plans designed to simplify transportation logistics and reduce administrative workload. These plans offer consistent service quality, easy billing, and close coordination with HR and operations teams for seamless employee transport management.`
  },
  {
    name: 'Industrial Area Employee Transport Dhule MIDC',
    description: `Optimized employee transport services for factories and industrial units in Dhule MIDC, focusing on safe and timely commutes. Our routing and scheduling comply with industrial regulations, ensuring smooth travel for all shifts.`
  },
  {
    name: 'Corporate Client Cabs Dhule MIDC',
    description: `Dedicated client transport services aimed at providing visiting business guests with a professional, comfortable, and punctual travel experience. From airport pickups to site visits, our polished vehicles and trained drivers help create a positive impression.`
  },
  {
    name: 'Business Meeting Cabs Dhule MIDC',
    description: `Rapid-response cab services tailored for executives attending urgent business meetings within Dhule and nearby areas. We provide quick booking, prompt dispatch, and experienced drivers to ensure timely arrivals and smooth travel.`
  },
  {
    name: 'Dhule Industrial Area Cab Hire',
    description: `Flexible on-demand cab hire services across Dhule’s industrial zones, supporting site visits, logistics tasks, and corporate errands. Our drivers’ familiarity with the industrial landscape guarantees efficient, hassle-free transportation.`
  },
  {
    name: 'Corporate Shuttle Cabs Dhule MIDC',
    description: `Group shuttle services using minibuses and large vans for bulk employee transportation during shift changes or corporate events. This service optimizes operational efficiency, lowers environmental impact, and ensures coordinated team travel.`
  }
],

tableData: [
  ['Dhule MIDC Corporate Cab Rentals', 'Employee Transport Cab Dhule MIDC'],
  ['Business Cab Services Dhule MIDC', 'Corporate Staff Cabs Dhule MIDC'],
  ['Reliable Corporate Cab Service Dhule MIDC', 'AC Corporate Cabs Dhule MIDC'],
  ['Staff Pickup and Drop Cab Dhule MIDC', 'Affordable Business Cab Rentals Dhule MIDC'],
  ['Executive Cab Services Dhule MIDC', 'Monthly Corporate Cab Rentals Dhule MIDC'],
  ['Industrial Area Employee Transport Dhule MIDC', 'Corporate Client Cabs Dhule MIDC'],
  ['Business Meeting Cabs Dhule MIDC', 'Dhule Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Dhule MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Dhule MIDC",
    "WhyChoosedescription": "eTravo delivers personalized cab services designed to meet the needs of businesses in Dhule MIDC. Our solutions ensure punctual and safe employee transportation, minimizing downtime and enhancing overall operational efficiency."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet features a variety of vehicles including sedans, SUVs, and multi-utility vehicles, allowing your business to select the perfect option for employee commutes, executive travel, or client visits. All vehicles are maintained to the highest standards."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are highly skilled and possess in-depth knowledge of Dhule MIDC’s roads and industrial areas, ensuring efficient navigation, timely pickups and drop-offs, and professional service."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We offer flexible booking options such as scheduled pickups, on-demand rides, and long-term contracts tailored to accommodate the varying shift patterns typical in industrial sectors."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All vehicles are equipped with GPS tracking, providing real-time monitoring to enhance safety, accountability, and ride transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear, itemized billing statements including trip details and fare breakdowns, facilitating easy financial management and reimbursement processes."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet undergoes regular sanitization and maintenance, with drivers adhering to strict hygiene protocols to ensure a clean and safe travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client benefits from a dedicated account manager who assists with bookings, resolves queries promptly, and ensures a seamless transportation experience in Dhule MIDC."
  }
]





}

const faqData = [
  [
    {
      question: "Which areas do your Dhule MIDC cab services cover?",
      answer: "Our cab services cover the full Dhule MIDC area and nearby industrial regions to ensure smooth employee and executive transport."
    },
    {
      question: "Can we arrange daily cabs for multiple shifts?",
      answer: "Yes, we offer flexible scheduling for multiple shifts including fixed, rotating, and night shift requirements."
    },
    {
      question: "Do you provide invoicing options for corporate clients?",
      answer: "Absolutely. We generate monthly GST-compliant invoices with a complete trip summary for easier business accounting."
    },
    {
      question: "Are your drivers experienced with MIDC transportation needs?",
      answer: "Yes, our drivers are professionally trained, route-aware, and follow all safety and punctuality standards."
    },
    {
      question: "What steps do you take to ensure passenger safety?",
      answer: "We provide GPS-enabled tracking, routine vehicle inspections, sanitized cabins, and verified drivers for passenger safety."
    },
    {
      question: "Is there a support system in place for business accounts?",
      answer: "Yes, corporate clients receive dedicated account managers and priority support for any service needs or queries."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Pravin Nikam",
    designation: "Operations Supervisor, Dhule AutoTech",
    rating: [1, 1, 1, 1, 1],
    text: "“With eTravo, we’ve seen a huge improvement in our team’s on-time arrivals. The service is reliable and consistent.”"
  },
  {
    name: "Ms. Anuja Pawar",
    designation: "HR Executive, Dhule Agro Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo provides excellent service with professional drivers and great support. Our employees feel safe and valued.”"
  }
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Dhule MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-dhule-midc.jpg",
  "description": "Reliable corporate cab service in Dhule MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-dhule-midc"
  }
};



    return (
        <div>

<Helmet>
  <title>Cab Service in Dhule MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Dhule MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceindhule;